/**
 * Aba aberta antes de um deploy: o index.html em memória aponta para arquivos JS
 * (um por rota) que o deploy novo apagou. Ao navegar para uma rota ainda não
 * carregada o import falha e a pessoa cai na tela de erro — típico logo após o login.
 * Recarregar a página busca o index.html novo e resolve.
 */

const RELOAD_KEY = 'zavy-stale-chunk-reload-at'
// Uma recarga por minuto no máximo: se o erro continuar depois de recarregar,
// não é aba antiga e a tela de erro tem que aparecer (sem laço de recarga).
const RELOAD_COOLDOWN_MS = 60_000

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i, // Chrome / Edge
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /Unable to preload CSS/i, // Vite
  /is not a valid JavaScript MIME type/i,
]

export function isStaleChunkError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

/** Recarrega a página, a menos que já tenha recarregado há pouco. Devolve se recarregou. */
export function reloadForStaleChunk(
  reload: () => void = () => window.location.reload(),
  now: number = Date.now(),
): boolean {
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
    if (now - lastReload < RELOAD_COOLDOWN_MS) return false
    sessionStorage.setItem(RELOAD_KEY, String(now))
  } catch {
    // Sem sessionStorage não dá para garantir uma recarga só — melhor mostrar o erro.
    return false
  }
  reload()
  return true
}
